import { config }         from './index.config';
import { routerConfig }   from './index.route';
import { i18nConfig }     from './i18n.config';
import { runBlock }       from './index.run';
import { tabConfig }      from './tab.config';
import { markdownConfig } from './markdown.config';
import { polyfills }       from './polyfills.config';


polyfills();

import angular from 'angular';

import 'angular-route';
import 'angular-messages';
import 'angular-sanitize';
import 'angular-jwt';
import 'angular-translate';
import 'angular-smart-table';
import 'angular-inview';
import 'angular-nvd3';

import 'angularjs-dropdown-multiselect';

import 'moment';
import 'moment-timezone';
import 'moment-duration-format';

import 'ng-showdown';
import 'ng-datepicker';

import "./api/api.module";

import "./theme/theme.module";
import "./work/work.module";
import "./stats/stats.module";
import "./auth/auth.module";
import "./admin/admin.module";
import "./admin/pCountry/tables/tables.module";
import "./controlling/controlling.module";
import "./management/management.module";
import "./termsOfUse/termsOfUse.module";
import "./caseman/caseman.module";
import "./360view/360view.module";
import "./licenseAgreement/licenseAgreement.module";
import "./overtimeApplications/overtimeApplications.module";

import "./react/react.module";

import mobxAngular from 'mobx-angularjs';

angular.module('frontend', [
  'ngRoute',
  'ngMessages',
  'ngSanitize',
  'angular-jwt',
  'pascalprecht.translate',
  'smart-table',
  "angular-inview",
  "nvd3",
  "ng-showdown",
  'angularjs-dropdown-multiselect',
  'frontend.api',
  'frontend.admin',
  'frontend.auth',
  'frontend.work',
  "frontend.management",
  'frontend.stats',
  'frontend.termsOfUse',
  "frontend.theme",
  "frontend.controlling",
  "frontend.caseman",
  "frontend.360view",
  "frontend.licenseAgreement",
  "frontend.overtimeApplications",
  'frontend.react',
  'frontend.adminCountryTables',
  mobxAngular
 ])
  .config(config)
  .config(i18nConfig)
  .config(routerConfig)
  .config(tabConfig)
  .config(markdownConfig)
  .run(runBlock);
